import ViewViewModel from '@/ViewModels/ViewViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class EmptyViewViewModel extends ViewViewModel {
}

ComponentManager.setViewModel('EmptyViewViewModel', EmptyViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');